export { default, type IOtpResendTimerProps } from './otp-resend-timer';
